// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ith {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 10px !important;
  text-align: left;
}

.Itd {
  border: 1px solid #dddddd;
  text-align: center;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 5px;
}

.tableI {
  border-collapse: collapse;
  width: 135%;
  margin: 1%;
  margin-top: 1%;
}

.incompleteOrdersTable {
  width: 99%;
}

.incompleteOrdersTableTR {
  margin-left: 80px;
  padding: 0px 6px 0px 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Incomplete.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".Ith {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 10px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Itd {\r\n  border: 1px solid #dddddd;\r\n  text-align: center;\r\n  border-left: none;\r\n  border-right: none;\r\n  border-top: none;\r\n  padding: 5px;\r\n}\r\n\r\n.tableI {\r\n  border-collapse: collapse;\r\n  width: 135%;\r\n  margin: 1%;\r\n  margin-top: 1%;\r\n}\r\n\r\n.incompleteOrdersTable {\r\n  width: 99%;\r\n}\r\n\r\n.incompleteOrdersTableTR {\r\n  margin-left: 80px;\r\n  padding: 0px 6px 0px 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
